module.exports = __webpack_public_path__ + "media/images/bg/footer-bg-4bb0bf29059a72818ec45ab1d31a61e0.jpg";